import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Form from "../../../../components/forms/index";
import { useCreateShopMutation, useGetShopCategoriesQuery } from "../../../../features/shop/shopApiSlice";
import { FailedNotify, SuccessNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
const HomeMadeItemsForm = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [displayimg, setDisplayimg] = useState();

  const { data: categoriesData } = useGetShopCategoriesQuery({
    type: "homemadeShop",
    parentCategory: "",
  });
  const shopCategoryone = categoriesData?.data?.Category || [];

  const [createShopMutation, { isLoading: isloading }] = useCreateShopMutation();

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setCreateShop((createShop) => ({
        ...createShop,
        image: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    }
    finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [selectshop, setSelectshop] = useState({
    shopCategory: ""
  });

  const Shopdatas = (e) => {
    setSelectshop((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = selectshop?.shopCategory[1];
  const categoryid = selectshop?.shopCategory[0];

  localStorage.setItem('mycategory', categoryName);

  const [createShop, setCreateShop] = useState({
    userid: name._id,
    shopname: "",
    shopaddress: "",
    shoplicense: "",
    contact: "",
    image: [""],
    isFoodShop: false,
    marketPlace: "",
    shopCategory: "",
    businessType: "homemadeShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    setCreateShop((createShop) => ({
      ...createShop,
      shopCategory: categoryid
    }
    ))

  }, [categoryid]);

  const PostShopData = async (e) => {
    e.preventDefault();



    try {
      const response = await createShopMutation(createShop).unwrap();
      if (response?.success) {
        setTimeout(() => {
          SuccessNotify("Form Home-Made Created Successfully");
          localStorage.setItem("shopid", response?.data?._id);
          navigate(`/rawmaterial-homemade/${response?.data?._id}`);
        }, 1000);
      }
    } catch (error) {
      if (error?.data?.message) {
        FailedNotify(error.data.message);
      } else {
        FailedNotify("Failed To Create Shop");
      }
    }
  };

  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }
  return (
    <Form
      title="Fill to create Home Made Items Shop"
      butn="Create"
      navigateTo="/rawmaterial-homemade"
      back="/homemade-integrate"
      CreateHandler={PostShopData}
      setCreateShop={setCreateShop}
      shopCategoryone={shopCategoryone}
      createShop={createShop}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      Shopdatas={Shopdatas}
      isUploading={isUploading}
      uploadProgress={uploadProgress}
    />
  );
};
export default HomeMadeItemsForm;
